/*!
 * devextreme-angular
 * Version: 24.1.3
 * Build date: Tue Jun 11 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */

/* tslint:disable:use-input-property-decorator */

import {
    Component,
    NgModule,
    Host,
    SkipSelf
} from '@angular/core';





import {
    NestedOptionHost,
} from 'devextreme-angular/core';
import { DxiFileManagerToolbarItem } from './base/file-manager-toolbar-item-dxi';


@Component({
    selector: 'dxi-file-selection-item',
    template: '',
    styles: [''],
    providers: [NestedOptionHost],
    inputs: [
        'cssClass',
        'disabled',
        'icon',
        'locateInMenu',
        'location',
        'name',
        'options',
        'showText',
        'text',
        'visible',
        'widget'
    ]
})
export class DxiFileSelectionItemComponent extends DxiFileManagerToolbarItem {

    protected get _optionPath() {
        return 'fileSelectionItems';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }



    ngOnDestroy() {
        this._deleteRemovedOptions(this._fullOptionPath());
    }

}

@NgModule({
  declarations: [
    DxiFileSelectionItemComponent
  ],
  exports: [
    DxiFileSelectionItemComponent
  ],
})
export class DxiFileSelectionItemModule { }
